import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import ShopLayout from "../Layout";
import GetShopBrandsList from "../../Brands";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import BreadCrumb from "../../Layouts/Breadcrumb";

const ShopBrandsList = (): ReactElement => {
  const route = useParams();
  return (
    <React.Fragment>
   
        <div className="content-body_ rounded-2xl">
          <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-0 mb-6">
            <GetShopBrandsList
              inShop={true}
              getShopId={(route as any)?.shopId}
            />
          </div>
        </div>
    </React.Fragment>
  );
};

ShopBrandsList.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default ShopBrandsList;
